import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import store from './store';
// import 'bootstrap/dist/css/bootstrap.min.css';


import AppRoute from './AppRoute';



ReactDOM.render(
	<Provider store={store}>
		<AppRoute />
	</Provider>,
	document.getElementById('root')
);
